import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllInvoices = async (business_id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/business/${business_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAdminInvoices = async (
  venueId?: string | null
): Promise<any> => {
  try {
    if (!venueId) {
      throw new Error("Venue ID is required to fetch admin invoices");
    }
    const response = await apiClient.get(
      `/invoices/getAdminInvoices/venue/${venueId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllOwnerInvoices = async (
  adminId?: string | null
): Promise<any> => {
  try {
    const id = adminId || getUserId();
    if (!id) {
      throw new Error("Admin ID is required to fetch owner invoices");
    }
    const response = await apiClient.get(
      `/invoices/getAdminInvoices/owner/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllInvoicesForUser = async (client_id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/getall/${client_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createInvoice = async (InvoiceData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/invoices/create", InvoiceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInvoice = async (
  id: string,
  InvoiceData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/invoices/update/${id}`, InvoiceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceById = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/getone/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceByAppointmentId = async (
  appointmentId: string
): Promise<any> => {
  try {
    const response = await apiClient.get(
      `/invoices/getone/byAppointmentId/${appointmentId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getInvoiceByIdInClient = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/getone/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInvoice = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/invoices/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
